import React, { useState } from "react";
import { Button, Modal } from "../ui";
import { sessionTimeout } from "../assets";

const SessionExpiryModal = ({ onStay, onLogout }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      iconSrc={sessionTimeout}
      title="Session Timeout"
      maxWidth="max-w-lg"
    >
      <div>
        <h3 className="text-h3 text-neutral-400">
          Your session is about to expire in 2 minutes. Would you like to stay signed in?
        </h3>
        <div className="flex items-center gap-4 justify-center mt-5">
          <Button onClick={onStay} variant="secondary">
            Stay signed in
          </Button>
          <Button onClick={onLogout} variant="error">
            Logout
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionExpiryModal;
